import { render, staticRenderFns } from "./Winners2019Photos.vue?vue&type=template&id=0ba3ef2e&"
import script from "./Winners2019Photos.vue?vue&type=script&lang=js&"
export * from "./Winners2019Photos.vue?vue&type=script&lang=js&"
import style0 from "./Winners2019Photos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports